import { useSelector } from 'react-redux'
import { Element } from '../../../../common/html/element'
import { Notification } from '../../../../common/notification'
import { TextEllipsisStaticLine } from '../../../../common/textEllipsis/TextEllipsisStaticLine'
import { FORMAT, formatDateTime } from '../../../../helpers/datetime'
import { LinkComponent } from '../../../common/html/LinkComponent'
import { TitleComponent } from '../../../common/html/TitleComponent'
import image from '../../../common/images/DefaultImage.png'
import classes from '../index.module.scss'
import { getDataNewsFeatured } from '../store/slice'

export const Featured = () => {
  const data = useSelector(getDataNewsFeatured)
  const locale = useSelector((state) => state.i18n.locale)

  return (
    <Element
      style={{ backgroundColor: '#FFFFFF' }}
      className={classes.featured}
    >
      <TitleComponent title="dashboard.featured.featured" />
      {!Object.keys(data)?.length ? (
        <Notification />
      ) : (
        <LinkComponent href={`${data?.sourceUrl}`} style={{ flex: 1 }}>
          <div
            style={{
              backgroundImage: `url(' ${
                data?.imageUrl ? data?.imageUrl : image
              }')`,
            }}
            className={classes.img}
          >
            <Element
              className="dFlex alignItemsCenter gap2"
              style={{
                backgroundColor: '#000000CC',
                opacity: 0.8,
                color: '#FFFFFF',
                padding: '4px 12px',
              }}
            >
              <Element
                className={classes.titleFeatured}
                style={{
                  lineHeight: '16px',
                }}
              >
                <TextEllipsisStaticLine
                  lineClamp={3}
                  text={data?.title || ''}
                  isI18n={false}
                />
              </Element>
              <Element
                elementName="span"
                className="fw400"
                style={{
                  fontSize: 10,
                  lineHeight: '12px',
                  whiteSpace: 'nowrap',
                }}
              >
                {formatDateTime(data?.publicDate, FORMAT.DATE, locale)}
              </Element>
            </Element>
          </div>
        </LinkComponent>
      )}
    </Element>
  )
}
